import { call, select } from 'redux-saga/effects';
import { selectActiveVenueId } from 'selectors/general';
import { makePath } from 'helpers/link-generation';

export const REDIRECT_HOME = 'REDIRECT_HOME';
export const redirectHome = () => ({ type: REDIRECT_HOME });

export function* doRedirectHome(client) {
  const venueId = yield select(selectActiveVenueId);
  yield call(client.navigate, makePath.home(venueId));
}
